import { useQuery } from '@tanstack/react-query'
import { webApi } from '@/services/webApi'
import type { TestimonialType } from '@/types/testimonial'

export function useTestimonials(type?: TestimonialType) {
  return useQuery({
    queryKey: ['web', 'testimonials', type ?? 'all'],
    queryFn: () => webApi.testimonials(type ? { type } : undefined),
  })
}
